import React from 'react';
import SideMenuLayout from '../layout/SideMenuLayout';
import AccountNav from './AccountNav';
import { AccountData } from './accountData';
import './AccountLayout.css';

interface Props { title: string; data: AccountData; children: React.ReactNode }

const AccountLayout: React.FC<Props> = ({ title, data, children }) => (
  <SideMenuLayout title={title} nav={<AccountNav data={data} />}>{children}</SideMenuLayout>
);

export default AccountLayout;
